<template>
  <div :class="['sub-field-list-input-container', !fieldConfig.fields && 'no-subfields']">
    <!-- {{fieldConfig}} -->
    <template v-if="!fieldConfig.fields">
      <template v-if="fieldConfig.valueType==='parameter'">
        <div class="sub-fields-container">
          <value-input-container :showLabel="showLabel" :showTooltip="showTooltip" :showUnits="showUnits" v-for="subVal in fieldConfig.value" :readOnly="readOnly" :key="subVal.id" :fieldConfig="subVal" v-on="$listeners"></value-input-container>
        </div>
      </template>
      <template v-else>
        <div class="sub-fields-container">
          <value-input-container :showLabel="showLabel" :showTooltip="showTooltip" :showUnits="showUnits" :readOnly="readOnly" :fieldConfig="fieldConfig" v-on="$listeners"></value-input-container>
        </div>
      </template>
    </template>
    <template v-else>
      <div class="sub-field-name">{{ fieldConfig.name }}</div>
      <div class="sub-fields-container">
        <value-input-container :showLabel="showLabel" :showTooltip="showTooltip" :showUnits="showUnits" :readOnly="readOnly" v-for="sf in fieldConfig.fields" :key="sf.id" :fieldConfig="sf" v-on="$listeners"></value-input-container>
      </div>
    </template>
  </div>
</template>

<script>
import ValueInputContainer from './ValueInputContainer'

export default {
  name: 'SubFieldListInputContainer',
  components: {ValueInputContainer},
  props: {
    fieldConfig: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    showTooltip: {
      type: Boolean,
      default: false
    },
    showLabel: {
      type: Boolean,
      default: true
    },
    showUnits: {
      type: Boolean,
      default: false
    }
  },
  model:{
    prop: 'fieldConfig',
    event: 'change'
  },
  data (){
    return {
    }
  },
  mounted () {
  },
  computed: {
  },
  watch:{
  }
}
</script>

<style lang="stylus" scoped>
.sub-field-list-input-container
  width: 100%;
  margin: 5px 0;
  >>> .value-input-component-container
    &:not(:last-child)
      margin-bottom: 15px

.sub-field-name
  color: $river-bed
  m-font-size(13, 16)
  margin-bottom: 15px
  text-transform: uppercase
</style>